import type { RadialGradientBGProps } from '@jouzen/ecom-components';
import { RadialGradientBG } from '@jouzen/ecom-components';
import { cx } from 'class-variance-authority';
import type { PropsWithChildren } from 'react';

export interface ImageWrapperProps extends PropsWithChildren {
  readonly imageGradientBg?: RadialGradientBGProps | undefined;
}

const ImageWrapper = ({ children, imageGradientBg }: ImageWrapperProps) => {
  const className =
    'aspect-square flex w-full items-center justify-center overflow-hidden md:rounded-lg lg:rounded-r-none xxl:rounded-r-lg';

  if (imageGradientBg) {
    return (
      <RadialGradientBG
        {...imageGradientBg}
        aria-live="polite"
        className={cx(className, imageGradientBg.className)}
      >
        {children}
      </RadialGradientBG>
    );
  } else {
    return (
      <div aria-live="polite" className={className}>
        {children}
      </div>
    );
  }
};

export default ImageWrapper;
